import type {RouteRecordRaw} from 'vue-router';

export const shopSettingsEmailRoutes: RouteRecordRaw[] = [
  {
    path: 'emails',
    name: 'shop-settings.emails',
    component: () => import('@/views/Settings/Shop/Emails/Emails.vue'),
    redirect: {name: 'shop-settings-emails-flows'},
    meta: {
      feature: 'page.settings.shop.emails',
      permissions: ['updateShopBranding'],
      title: (t) => t('settings.shop.emails.email', 2),
      titleBarHeader: 'shipment.menu.items.emails',
    },
    children: [
      {
        path: '',
        name: 'shop-settings-emails-flows',
        components: {
          emailSettings: () => import('@/views/Settings/Shop/Emails/EmailFlows/EmailFlows.vue'),
        },
        meta: {
          title: (t) => t('settings.shop.emails.tabs.emails'),
        },
      },
      {
        path: 'settings',
        name: 'shop-settings-emails-settings',
        components: {
          emailSettings: () => import('@/views/Settings/Shop/Emails/EmailSettings/EmailSettings.vue'),
        },
        meta: {
          title: (t) => t('settings.shop.emails.tabs.settings'),
        },
      },
    ],
  },
];
